import { jwtDecode } from 'jwt-decode'
import type { IdTokenPayload, PersistedAuthState } from '../model/auth.types'

export const AUTH_CONSTANTS = {
  STORAGE_KEY: 'auth',
} as const

/**
 * Decode JWT token to extract payload
 * Note: This does NOT verify the token signature
 */
export function decodeIdToken(idToken: string): IdTokenPayload {
  return jwtDecode<IdTokenPayload>(idToken)
}

/**
 * Check if token is already expired
 */
export function isTokenExpired(expiresAt: number): boolean {
  const now = Math.floor(Date.now() / 1000)
  return now >= expiresAt
}

/**
 * Load auth state from localStorage
 */
export function loadPersistedAuth(): PersistedAuthState | null {
  try {
    const stored = localStorage.getItem(AUTH_CONSTANTS.STORAGE_KEY)
    if (!stored) return null

    const parsed = JSON.parse(stored) as PersistedAuthState

    // Validate required fields
    if (!parsed.accessToken || !parsed.expiresAt) {
      return null
    }

    return parsed
  } catch {
    return null
  }
}

/**
 * Save auth state to localStorage
 */
export function persistAuth(state: PersistedAuthState): void {
  localStorage.setItem(AUTH_CONSTANTS.STORAGE_KEY, JSON.stringify(state))
}

/**
 * Clear auth state from localStorage
 */
export function clearPersistedAuth(): void {
  localStorage.removeItem(AUTH_CONSTANTS.STORAGE_KEY)
}
